export default __webpack_public_path__ + "static/media/profile.01d3b5aa.png";